<app-modal-header (closeModal)="close()"></app-modal-header>
@defer (when attendees.length > 0) {
  <app-modal-body>
    <h1 class="fw-medium fs-5 mb-3">{{ 'WHO_WOULD_YOU_LIKE_TO_MEET' | translate }}</h1>
    <div class="row gx-2">
      @for (item of attendees; track $index) {
        <div
          class="col-4 mb-3"
          (click)="showModalRequestMeet(item)"
          (keydown.space)="showModalRequestMeet(item)"
          tabindex="0"
        >
          <ng-template #cardAttendees></ng-template>
        </div>
      }
    </div>
  </app-modal-body>
} @placeholder {
  @if (attendees.length === 0) {
    <app-modal-body>
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '30px',
          borderRadius: '8px',
        }"
      />
      <div class="row mt-3">
        @for (item of [].constructor(8); track $index) {
          <div class="col-12 mb-2 col-lg-4">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '180px',
                borderRadius: '20px',
              }"
            />
          </div>
        }
      </div>
    </app-modal-body>
  }
}
